// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1gvxQ","row":"styles_row__3ArP5"};